<template>
  <div class="jobfair-job light-bg-skin">
    <side-bar>
      <header-nav ref="router"></header-nav>
      <base-login @logined="init"></base-login>
      <jobfair-info
        v-if="video_jobfair_id"
        :video_jobfair_id="video_jobfair_id"
        @init="getDetail"
      ></jobfair-info>
      <el-container class="container" v-loading="loading">
        <el-main>
          <card-base :style-object="style.top" :margin-object="style.topMargin">
            <el-row>
              <el-col :span="18" class="job-detail-item">
                <p>
                  <span class="text-bold">{{ job_info.job_name }}</span>
                  <span class="text-light">{{ job_info.salary }}</span>
                </p>
                <p class="text-introduce">
                  <span class="text-normal" v-show="job_info.city_name">
                    {{ job_info.city_name }}
                  </span>
                  <span class="text-normal" v-show="job_info.degree_require">
                    {{ job_info.degree_require }}
                  </span>
                  <span class="text-normal" v-show="job_info.job_number">
                    {{ job_info.job_number }}人
                  </span>
                  <span class="text-normal" v-show="job_info.about_major">
                    {{ job_info.about_major }}
                  </span>
                </p>
                <p class="keywords-list">
                  <template v-for="(item, index) in job_info.keywords_arr">
                    <span class="keywords-item" :key="index" v-if="item">
                      {{ item }}
                    </span>
                  </template>
                </p>
              </el-col>
              <el-col :span="6" class="tr">
                <invite-resume
                  :params="job_info"
                  :video_jobfair_id="video_jobfair_id"
                  type="primary"
                ></invite-resume>
                <el-button
                  type="primary"
                  :icon="
                    collect_data.is_collect
                      ? 'el-icon-star-on'
                      : 'el-icon-star-off'
                  "
                  size="mini"
                  @click="collectFn()"
                  v-loading="collect_data.loading"
                  >{{ collect_data.is_collect ? "已" : "" }}收藏</el-button
                >
              </el-col>
            </el-row>
          </card-base>

          <el-row :gutter="20">
            <el-col :span="16">
              <card-base
                :style-object="style.content"
                :margin-object="style.topMargin"
              >
                <div class="detail-card-publisher" v-if="job_info.hr">
                  <img :src="job_info.hr.logo_url || 'https://yun-campus-res.oss-cn-shenzhen.aliyuncs.com/company/login/default_logo.png'" class="publisher-photo" />
                  <div class="publisher-info">
                    <p><span class="name">{{job_info.hr.user_name}}</span><span class="info-position" v-if="job_info.publish_log">发布于{{job_info.publish_log ? job_info.publish_log.province : ''}}</span></p>
                    <p class="job">{{job_info.hr.department}}</p>
                  </div>
                  <div class="publisher-chat">
                    <el-popover placement="right" width="250" trigger="hover" @show="showDialog">
                      <div class="program-popover">
                          <el-image :src="trendsUrl" class="code-img"></el-image>
                          <p>打开【微信】-【扫一扫】来跟我聊聊吧</p>
                      </div>
                      <el-button
                        slot="reference"
                        icon="el-icon-chat-dot-round"
                        size="mini"
                        type="primary"
                        :plain="false"
                      >聊聊</el-button>
                  </el-popover>
                  </div>
                </div>
                <div class="icon-box" v-if="job_info.job_descript">
                  <h2>
                    <span class="icon-circle">
                      <i class="iconfont icongongzuotai"></i>
                    </span>
                    <span class="icon-text">岗位职责</span>
                  </h2>
                  <div
                    class="company-text"
                    style="line-height: 0.24rem"
                    v-html="job_info.job_descript"
                  ></div>
                </div>
                <div class="icon-box" v-if="job_info.intro_apply">
                  <h2>
                    <span class="icon-circle">
                      <i class="iconfont icongongzuotai"></i>
                    </span>
                    <span class="icon-text">简历投递说明</span>
                  </h2>
                  <div
                    class="company-text"
                    style="line-height: 0.24rem"
                    v-html="job_info.intro_apply"
                  ></div>
                </div>
                <div class="icon-box" v-if="job_info.job_require">
                  <h2 style="margin-top: 0">
                    <span class="icon-circle">
                      <i class="iconfont icongongzuotai"></i>
                    </span>
                    <span class="icon-text">岗位要求</span>
                  </h2>
                  <div
                    class="company-text"
                    style="line-height: 0.24rem"
                    v-html="job_info.job_require"
                  ></div>
                </div>
                <div class="icon-box" v-if="job_info.job_other">
                  <h2>
                    <span class="icon-circle">
                      <i class="iconfont icongongzuotai"></i>
                    </span>
                    <span class="icon-text">其它描述</span>
                  </h2>
                  <div
                    class="company-text"
                    style="line-height: 0.24rem"
                    v-html="job_info.job_other"
                  ></div>
                </div>
              </card-base>
            </el-col>
            <el-col :span="8">
              <card-base
                :style-object="style.top"
                :margin-object="style.topMargin"
              >
                <el-row
                  style="cursor: pointer"
                  :gutter="10"
                  v-if="job_info.company_info.company_id"
                  @click.native="goDetail(job_info.company_info.company_id)"
                >
                  <el-col :span="4">
                    <el-image
                      style="width: 0.4rem; height: 0.4rem"
                      :src="job_info.company_info.logo_url"
                      fit="contain"
                    >
                      <div slot="error" class="image-slot">
                        <img class="el-image__inner" style="object-fit: contain;" :src="$util.error_company_logo" alt="" />
                      </div>
                    </el-image>
                  </el-col>
                  <el-col :span="20">
                    <p>
                      <span class="icon-text">
                        {{ job_info.company_info.company_name }}
                      </span>
                    </p>
                    <p>
                      <span>{{ job_info.company_info.city_name }}</span>
                    </p>
                  </el-col>
                </el-row>
                <div class="company-text mt-16" style="line-height: 0.24rem" >
                        <i class="el-icon-location-outline f16"></i>
                        {{ job_info.company_info.address }}
                </div>
                <!-- <baidu-map :props-style="style.map" ref="baidu-map"></baidu-map> -->
              </card-base>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
      <footer-box></footer-box>
    </side-bar>
  </div>
</template>

<script>
import { mapState } from "vuex";

import CardBase from "@/components/Card/CardBase";
// import BaiduMap from "@/components/Map/Map";

import InviteResume from "@/components/Invite/InviteResume";

export default {
  name: "jobfair-job",
  components: {
    CardBase,
    // BaiduMap,
    InviteResume,
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  data() {
    return {
      style: {
        top: {
          padding: "0.3rem",
        },
        topMargin: {
          margin: "0.2rem 0",
        },
        map: { height: "2rem", width: "100%" },
        content: {
          padding: "0.3rem",
          minHeight: "3.6rem",
        },
      },
      publish_id: "",
      video_jobfair_id: "",
      video_erp_register_id: "",
      job_info: {
        publish_id: 0,
        company_info: {},
      },

      collect_data: {
        loading: false,
        is_collect: false,
      },
      loading: true,
      trendsUrl: '',//企业动态小程序图
    };
  },
  created: function () {
    this.init();
  },
  methods: {
    init: function () {
      var publish_id = this.$util.getQueryString("publish_id");
      var video_jobfair_id = this.$util.getQueryString("video_jobfair_id");
      var video_erp_register_id = this.$util.getQueryString(
        "video_erp_register_id"
      );

      this.publish_id = publish_id;
      this.video_jobfair_id = video_jobfair_id;
      this.video_erp_register_id = video_erp_register_id;

      if (!video_jobfair_id) {
        this.getDetail();
      }
    },
     //获取小程序二维码
    getMiniCode(){
      let params = {
        scene: 'publish_id='+this.publish_id,
        page: 'pages/seeker/jobs/detail/main',
        type: 'dynamic'
      }
      
      this.$util.get('kzp_person', 'programe_code', params).then((res) => {
        let {code,data,msg} = res
        if(code == 1){
          this.trendsUrl = data
        }
      })
    },
    getDetail: function () {
      var _self = this;
      _self.loading = true;
      const { publish_id, video_jobfair_id, video_erp_register_id } = this;

      this.$util
        .get("kzp_video_jobfair", "get_job_info", {
          job_id: publish_id,
          video_erp_register_id: video_erp_register_id,
          show_company_info: 1,
        })
        .then((res) => {
          _self.loading = false;
          if (res.code !== 1) {
            if (res.msg) {
              _self.$message.error(res.msg);
            }
            return;
          }

          if (res.data && res.data.length < 1) {
            _self.$message.error("未知的职位信息");
            setTimeout(function () {
              _self.$util.pageto("job", {});
            }, 3000);
            return;
          }

          let job_info = res.data;

          // 富文本过滤
          job_info.job_descript = _self.$util.filterRichText(
            job_info.job_descript
          );
          job_info.job_other = _self.$util.filterRichText(job_info.job_other);
          job_info.intro_apply = _self.$util.filterRichText(
            job_info.intro_apply
          );
          job_info.job_require = _self.$util.filterRichText(
            job_info.job_require
          );

          // 字符串转数组
          job_info.keywords_arr = job_info.keywords
            ? job_info.keywords.split(" ")
            : [];
          _self.$util.tansPics(job_info.company_info, "logo_url", {
            default_img: _self.$util.error_company_logo,
          });

          if (job_info.company_info) {
            var company_info = job_info.company_info;

            // _self.$refs["baidu-map"].mapFn({
            //   title: company_info.company_name,
            //   address: company_info.address,
            //   city: company_info.city_name,
            //   is_open: false,
            // });
          }

          _self.job_info = job_info;

          _self.collect_data.is_collect = job_info.has_collect ? true : false;
        })
        .catch(() => {
          // 处理不提示的错误!
        });
    },

    // 收藏 ajax_add_collect
    // 取消收藏 ajax_cancel_collect_job
    collectFn: function () {
      var _self = this;

      const { publish_id } = this;

      if (_self.collect_data.loading || !publish_id) {
        return;
      }

      _self.collect_data.loading = true;

      let action = "add_collect";
      if (_self.collect_data.is_collect) {
        action = "cancel_collect_job";
      }

      this.$util
        .post("kzp_video_jobfair", action, {
          job_id: publish_id,
        })
        .then((res) => {
          _self.collect_data.loading = false;

          if (res.code !== 1) {
            if (res.msg) {
              _self.$message.error(res.msg);
            }
            return;
          }

          _self.collect_data.is_collect = !_self.collect_data.is_collect;
        })
        .catch(() => {
          // 处理不提示的错误!
        });
    },

    goDetail(id) {
      this.$util.pageto("company_detail", { company_id: id });
    },
    /**
     * 显示二维码弹窗
     */
    showDialog(){
      if(this.trendsUrl){
        return;
      }
      this.getMiniCode();
    },
  },
};
</script>

<style lang="scss" scoped>
.mt-16 {
  margin-top: 16px;
}
.jobfair-job {
  height: 100%;

  .icon-box {
    margin-bottom: 0.2rem;

    h2 {
      $boxSize: 0.25rem;
      line-height: $boxSize;
      overflow: hidden;
      margin: 0 0 0.1rem;

      > span {
        float: left;
      }

      .icon-circle {
        display: inline-block;
        width: $boxSize;
        height: $boxSize;
        line-height: $boxSize;
        text-align: center;
        background-color: $lightColor;
        color: #fff;

        margin-right: 0.08rem;
        @include border-radius(50%);

        .iconfont {
          vertical-align: text-top;
          font-size: 0.12rem;
        }
      }

      .icon-text {
        display: inline-block;
        font-size: 0.18rem;
        line-height: $boxSize;
        font-weight: bold;
        color: #282828;
      }
    }
  }

  .company-text {
    font-size: 0.14rem;
    font-weight: 500;
    color: #999999;
  }

  .company-bold-text {
    font-size: 0.16rem;
    font-weight: bold;
    color: #282828;
  }

  .keywords-list {
    padding-top: 0.15rem;

    .keywords-item {
      padding: 0.03rem 0.08rem;
      font-size: 0.12rem;
      color: #999999;
      background: #f3f3f3;
      @include border-radius(0.05rem);
      margin-right: 0.1rem;
      margin-bottom: 0.1rem;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .job-detail-item {
    p {
      @include over-ellipsis();
    }

    p.text-introduce {
      margin-top: 0.07rem;

      .text-normal {
        border-right: 1px solid #999999;

        &:last-child {
          border-right: none;
        }
      }
    }

    .text-bold {
      font-size: 0.18rem;
      font-weight: bold;
      line-height: 0.25rem;
      color: #282828;
    }

    .text-normal {
      font-size: 0.12rem;
      font-weight: 400;
      line-height: 0.2rem;
      color: #999999;
      padding: 0 5px;
    }

    .text-light {
      font-size: 0.14rem;
      font-weight: bold;
      line-height: 0.2rem;
      color: #f6404d;
    }

    .text-highlight {
      color: $lightColor;
      font-size: 0.14rem;
      font-weight: bold;
      line-height: 0.2rem;
    }

    .text-normal-bold {
      font-size: 0.16rem;
      font-weight: 500;
      line-height: 0.22rem;
      color: #282828;
    }
  }

  .slider-footer {
    background: #fff;
    padding-top: 45px;
  }
}
.detail-card-publisher{
  display: flex;
  align-items: center;
  height: 70px;
  margin: 15px 0 20px;
  .publisher-photo{
    width: 70px;
    height: 70px;
    margin-right: 20px;
    border-radius: 50%;
    background: #f5f5f5;
  }
  .publisher-info{
    flex: 1;
    .name{
      display: inline-block;
      font-size: 18px;
      color: #3A3A3A;
      margin-right: 14px;
      font-weight: 600;
      line-height: 25px;
    }
    .job{
      font-size: 14px;
      font-weight: 500;
      color: #999999;
      line-height: 1.9;
    }
    
    .info-position{
      display: inline-block;
      padding: 0 13px;
      height: 25px;
      font-size: 12px;
      color: #707070;
      line-height: 25px;
      background: #F7F7F7;
      border-radius: 3px 3px 3px 3px;
      box-sizing: border-box;
      transform: translateY(-2px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/seeker/job/detail/App.vue